<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-2">
    <div>
      {{ t("account-setting.account_settings_insctructions") }}
    </div>
    <div class="ag-theme-quartz flex-1">
      <ag-grid-angular class="h-full w-full" [gridOptions]="gridOptions" />
    </div>
  </div>
</ng-container>
